// extracted by mini-css-extract-plugin
export default {"root":"DMP0kolW"};